
import {api_host, token } from '../common/constants'

export const getObjectiveLastStatus = (objective) =>
    fetch(`${api_host}/reporte/especial/getLastStatusObjective/?user=1&token=${token}&objetivoId=${objective}`)
    .then(response => response.json())     
